const scrollToTopButton = document.getElementById('js-top')

if (scrollToTopButton) {
    const scrollFunc = () => {
        const y = window.scrollY

        if (y > 0) {
            scrollToTopButton.className = 'back-to-top show'
            document.body.classList.add('scrolled')
        } else {
            scrollToTopButton.className = 'back-to-top hide'
            document.body.classList.remove('scrolled')
        }
    }

    window.addEventListener('scroll', scrollFunc)

    const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop

        // If that number is greater than 0, we'll scroll back to 0, or the top of the document.
        // We'll also animate that scroll with requestAnimationFrame:
        // https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
        if (c > 0) {
            window.requestAnimationFrame(scrollToTop)
            // ScrollTo takes an x and a y coordinate.
            // Increase the '10' value to get a smoother/slower scroll!
            window.scrollTo(0, c - c / 10)
        }
    }

    scrollToTopButton.onclick = function (e) {
        e.preventDefault()
        scrollToTop()
    }
}
